import styled from 'styled-components'
import { myPalette } from '~/shared/ui/theme'

export const ButtonWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  cursor: pointer;
`

export const Title = styled.div`
  color: ${myPalette.white.main};
  font-size: 16px;
`
